import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import {
  IEditableRequestData,
  IRequestData,
} from 'legacy/lut/classes/models/onboarding/IRetailRequestData'
import { getOtherContactsWithSameRole } from 'legacy/lut/helpers/contacts/getOtherContactsWithSameRole'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const fetchEmailContactInAnotherPartner = async (partnerId: string, email: string) => {
  const crud = CrudStore.get(CrudStoreItem.ContactAllData, `CheckContact`)
  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'TopPartnerID',
        operator: Operator.NOTEQUAL,
        value: partnerId,
      },

      {
        field: 'Email',
        operator: Operator.EQUAL,
        value: email,
      },
    ],
  })
  const result = await crud.fetch()

  return result.items[0] ?? null
}

export const checkExistContactsWithSameRole = async (
  editableRequestData: IEditableRequestData,
  requestData: IRequestData,
  role: string,
  field: string
) => {
  if (editableRequestData[field]) {
    const result = await getOtherContactsWithSameRole({
      checkingRole: role,
      partnerId: requestData.PartnerId,
      keyField: 'Email',
      keyValue: editableRequestData[field],
      crudUniqueKey: 'check-contact-roles',
    })
    if (result && result.items.length) {
      return true
    }
  }
  return false
}
